<div class="actions flex justify-end gap-4">
  <lib-split-action-button
    [primaryLabel]="'patientSearch_chart_button' | translate"
    [primaryIcon]="'px-24-chart'"
    [primaryAction]="onChartMenuItemClick"
    [menuItems]="menuItems()"
  ></lib-split-action-button>
</div>
